import React from 'react';
import { ColumnsType } from 'antd/es/table';

import { getTableSortOrder } from '../../common/getTableSortOrder';
import { LinkTableCell } from '../../components/LinkTableCell';
import { PageRoutesEnum } from '../../utils/routes';

import { CandidatesDataType } from './useCandidateTableDataSource';

export const useCandidateTableColumnDefinitions = ({
  sortedInfo,
}: {
  sortedInfo: { field: string; order: string }[];
  withLocalSorting?: boolean;
}): ColumnsType<CandidatesDataType> => {
  const candidateColumns = [
    {
      title: 'First name',
      dataIndex: 'firstName',
      width: 180,
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'firstName'),
    },
    {
      title: 'Last name',
      dataIndex: 'lastName',
      width: 180,
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'lastName'),
    },
    {
      title: 'Applied Position',
      dataIndex: 'appliedPosition',
      width: 180,
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'appliedPosition'),
    },
    {
      title: 'Created date',
      dataIndex: 'createdDate',
      width: 180,
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'createdDate'),
    },
    {
      title: 'Recommended by',
      dataIndex: 'recommendedBy',
      width: 180,
      sorter: {
        compare: () => 0,
        multiple: 1,
      },
      sortOrder: getTableSortOrder(sortedInfo, 'recommendedBy'),
    },
    {
      title: 'Exp. Salary',
      dataIndex: 'expectedSalary',
      width: 180,
    },
  ];

  return candidateColumns.map((column) => ({
    ...column,
    render: (text: string, record: CandidatesDataType) => (
      <LinkTableCell text={text} record={record} pageRoute={PageRoutesEnum.candidateEdit} />
    ),
  }));
};
